import $ from 'jquery';

export default function megaMenuSearch() {
  const form = $('.search-form--people');
  const btn = form.find('.search-form__btn');
  const action = form.attr('action');

  btn.on('click', function (e) {
    e.preventDefault();

    const name = form.find('.search-form__name').val();
    const countries = form.find('.search-form__countries').val();
    const expertises = form.find('.search-form__expertises').val();

    const searchObject = {};

    if (name) searchObject['_people_search'] = name;
    if (countries) searchObject['_people_countries'] = countries;
    if (expertises) searchObject['_people_expertise'] = expertises;

    if (Object.entries(searchObject).length > 0) {
      window.location.href = action + 'people/?' + $.param(searchObject);
    }
  });
};
